const For = {}

// Function to get current language dynamically
const getLanguage = () => {
  const lang = document.documentElement.lang;
  // In dev mode, the PHP comment might not be processed, so extract language from URL
  if (!lang || lang.includes('<!--') || lang.includes('<?php')) {
    const pathLang = window.location.pathname.split('/')[1];
    if (pathLang === 'en' || pathLang === 'fi') {
      return pathLang;
    }
    return null;
  }
  return lang || null;
};

/* GENERAL QUERY STRUCTURE FOR IMAGES */
For.Images = {
  query: 'page.images',
  select: {
    id: true,
    filename: true,
    url: true,
    width: 'file.width()',
    height: 'file.height()',
    ratio: 'file.ratio()',
    srcset: 'file.srcset([250, 450, 800, 1440])',
    /* webp: 'file.srcset("webp")', */
    /* avif: 'file.srcset("avif")' */
  }
};

/* QUERY STRUCTURE FOR DOCUMENTS */
For.Files = {
  query: 'page.files',
  select: {
    id: true,
    filename: true,
    url: true
  }
};

/* BASE FIELDS FOR PAGES */
const getBase = () => {
  const language = getLanguage();
  return {
    title: language ? 'page.contentLang("' + language + '").title' : true,
    content: language ? 'page.contentLang("' + language + '")' : true,
    url: language ? 'page.url("' + language + '")' : true,
    id: true,
    //uuid: 'page.uuid',
    uid: true,
    listed: 'page.isListed',
    images: For.Images,
    files: For.Files,
  };
};

/* GENERAL QUERY STRUCTURE FOR CHILDREN */
For.Children = (() => {
  const Base = getBase();
  return {
    ...Base,
    children: {
      query: 'page.children',
      select: {
        ...Base,
      }
    }
  };
})();

/* PAGES */
/* ===== */

For.Default = (() => {
  const Base = getBase();
  const language = getLanguage();
  return {
    ...Base,
    text: language ? 'page.contentLang("' + language + '").text.kirbytext' : 'page.text.kirbytext',
  };
})();

For.Home = (() => {
  const Base = getBase();
  const language = getLanguage();
  return {
    ...Base,
    layout: language ? 'page.contentLang("' + language + '").layout.toBlocks()' : 'page.layout.toBlocks()',
  };
})();

For.Site = {
  content: true,
};

export default {
  For
}
